<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.expenseStart')" prop="startTimeBegin">
            <BjDateRangePicker v-model="queryParamsTime" :placeholder="$t('billingPage.expenseStart')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.expenseEnd')" prop="endTimeBegin">
            <BjDateRangePicker v-model="queryParamsTime2" :placeholder="$t('billingPage.expenseEnd')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
        </el-col>
      </template>

      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else>{{ scope.row[col.prop] | timeFilters({isSession:false, dateFormat:'DD/MM/YYYY'}) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
              <el-button type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @handleConfirm="handleConfirm" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { userApi } from '@/api';
import DataForm from './components/DataForm.vue';

export default {
  name: 'BusinessBillingExpense', 
  components: { DataForm },
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 8,
      // 查询参数
      queryApi: userApi.getExpenseMangList,
      queryParamsTime: [],
      queryParamsTime2: [],
      queryParams: {
        startTimeBegin:null,
        startTimeEnd:null,
        endTimeBegin: null,
        endTimeEnd: null,
      },
      labelList: [
        { label: this.$t('billingPage.expenseLabour'), prop: 'officeLabour', isCheck: true, disabled: false },
        { label: this.$t('billingPage.expenseExpense'), prop: 'officeExpense', isCheck: true, disabled: false },
        { label: this.$t('billingPage.expenseWareh'), prop: 'warehouseExpense', isCheck: true, disabled: false },
        { label: this.$t('billingPage.startDate'), prop: 'startDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.endDate'), prop: 'endDate', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 140 },
      ],
      templateList:[],
    };
  },
  computed: {},
  watch: {
    queryParamsTime(v) {
      this.queryParams.startTimeBegin = (v || [])[0];
      this.queryParams.startTimeEnd = (v || [])[1];
    },
    queryParamsTime2(v) {
      this.queryParams.endTimeBegin = (v || [])[0];
      this.queryParams.endTimeEnd = (v || [])[1];
    },
  },
  methods: {
    // 新增
    onAdd() {
      this.$refs.DataForm.drawer = true;
    },
    // 编辑  
    onEdit(row) {
      this.$refs.DataForm.drawer = true;
      this.$refs.DataForm.form = JSON.parse(JSON.stringify(row));
      this.$refs.DataForm.queryParamsTime = [new Date(row.startDate),new Date(row.endDate)];
    },
    // 删除
    onDelete(row) {
      this.$confirm(this.$t('ChannelWarehouseManagement.Main.ps'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('okText'),
        cancelButtonText: this.$t('cancelText'),
        type: 'warning',
      }).then(() => {
          userApi.modifyExpenseMangList({id:row.id,isDelete:1}).then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            }
          });
        })
    },
    // 子页面回调执行  '新增'  或者 '编辑' 方法
    handleConfirm(handleForm) {
      // 判断逻辑 ==> id存在就是编辑，否则就是新增
      if (handleForm.id) {
        userApi.modifyExpenseMangList({...handleForm,isDelete:0}).then(() => {
          this.$refs.DataForm.handleClose();
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        });
      } else {
        userApi.addExpenseMangList(handleForm).then(() => {
          this.$refs.DataForm.handleClose();
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        });
      }
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = [],
      this.queryParamsTime2 = [],
      this.queryParams = {
        page: 0,
        startTimeBegin:'',
        startTimeEnd:'',
        endTimeBegin: '',
        endTimeEnd: '',
      };
      return new Promise(resolve => {
        resolve();
      });
    },

  },
};
</script>